import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, Typography, Button, TextField, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Navbar from './Navbar';
import RightSide from './RightSide';
import logo from '../assets/logo.png';
import { useForm, ValidationError } from '@formspree/react';
import { api_Routes } from "../api_Route";
import { Helper } from "../Tools/Helper";
import { useSnackbar } from "notistack";

function Login() {
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:768px)');
    const [state, handleSubmit] = useForm("mgvojbaq");

    const [formData, setFormData] = useState({ name: '', username: '', email: '', password: '' });

    useEffect(() => {
        setFormData({ name: fullName, username: fullName, email, password });
    }, [fullName, email, password]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!fullName || !email || !password) {
            setError("جميع الحقول مطلوبة");
            return;
        }
        const formspreeResponse = await handleSubmit(e);
        handleApiSubmit();
    };

    const handleApiSubmit = async () => {
        setIsLoading(true);
        try {
            const { response, message } = await Helper.Put({
                url: api_Routes.auth.register,
                data: { name: fullName, username: fullName, email, password },
                hasToken: false,
            });

            if (response) {
                enqueueSnackbar(message, { variant: "success" });
                localStorage.setItem("user", JSON.stringify({
                    user_id: response.data?.id,
                    token: response.data?.token,
                    username: response.data?.username,
                }));
                navigate("/otp");
            } else {
                enqueueSnackbar(message || "حدث خطأ أثناء العملية.", { variant: "error" });
            }
        } catch {
            enqueueSnackbar("حدث خطأ أثناء إرسال النموذج.", { variant: "error" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <Stack
                direction={isMobile ? "column" : "row"}
                sx={{ borderLeft: "30px solid #15513c", minHeight: "100vh" }}
            >
                {/* Left Side - Login Form */}
                <Stack
                    alignItems="center"
                    sx={{
                        flexBasis: isMobile ? "100%" : "50%",
                        justifyContent: "center",
                        px: isMobile ? 2 : 0,
                        py: isMobile ? 4 : 0
                    }}
                >
                    <Stack sx={{ width: "90%", maxWidth: "400px" }} spacing={3}>
                        <Box sx={{ textAlign: "center" }}>
                            <img src={logo} alt="Logo" width="60px" />
                        </Box>

                        <Box textAlign="center">
                            <Typography variant="h6" fontWeight="bold">
                                مرحبًا بك مجددًا في منصة نبني
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                قم بتسجيل الدخول للوصول إلى ملفك الشخصي، تحديث احتياجاتك، وتتبع حالة طلبات الدعم
                            </Typography>
                        </Box>

                        <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }} onSubmit={handleFormSubmit}>
                            <TextField
                                label="الاسم الكامل"
                                variant="outlined"
                                fullWidth
                                placeholder="قم بإدخال اسمك الكامل (اسمك وكنيتك)"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                name="fullName"
                            />
                            <TextField
                                label="البريد الإلكتروني"
                                variant="outlined"
                                fullWidth
                                placeholder="قم بإدخال بريدك الإلكتروني"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                            />
                            <TextField
                                label="كلمة المرور"
                                variant="outlined"
                                fullWidth
                                placeholder="قم بإدخال كلمة المرور"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                name="password"
                            />

                            {error && (
                                <Typography variant="body2" color="error" textAlign="center">
                                    {error}
                                </Typography>
                            )}
                            <Typography variant="body2" textAlign="center" color="textSecondary">
                                يرجى إدخال بريد إلكتروني صالح لاستلام رمز التحقق المؤلف من 6 أرقام
                            </Typography>

                            <ValidationError prefix="Email" field="email" errors={state.errors} />
                            <ValidationError prefix="FullName" field="fullName" errors={state.errors} />

                            <Button
                                variant="contained"
                                fullWidth
                                sx={{ backgroundColor: "#15513c", color: "#fff", borderRadius: "6px", py: 1.5 }}
                                type="submit"
                                disabled={state.submitting || isLoading}
                            >
                                <ArrowBackIcon sx={{ ml: 1 }} />
                                إرسال
                            </Button>
                        </Box>
                    </Stack>
                </Stack>

                {/* Right Side (Hidden on Mobile) */}
                {!isMobile && <RightSide />}
            </Stack>
        </>
    );
}

export default Login;
